/* STEFANO - PATCH TEMPORANEA capsule - GESTIONE ESCLUSIONI TAGLIE (generica)
   ----------------------------------------------------------------
   Nasconde VISIVAMENTE una o più taglie nel configuratore Mix & Match,
   in base a REGOLE configurabili:
     - RULES: match per TAG prodotto (es. 'elisavisari')
     - HANDLE_RULES: match per HANDLE prodotto specifico (lista esplicita)

   ==================================================================
   COME AGGIUNGERE/MODIFICARE UNA REGOLA PER TAG
   ==================================================================
   {
     tag: 'nome-tag',
     size: 'xl',
     excludedTitleWords: ['parola', ..]  // opzionale
   }

   ==================================================================
   COME AGGIUNGERE/MODIFICARE UNA REGOLA PER HANDLE
   ==================================================================
   { handles: ['handle-prodotto-1', 'handle-prodotto-2'], size: 'xs' }

   Un prodotto può matchare più regole insieme (es. nascondere sia
   XL che XS sullo stesso prodotto se soddisfa entrambe le regole).
   ---------------------------------------------------------------- */
(function () {
  'use strict';

  var RULES = [
    {
      tag: 'elisavisari',
      size: 'xl',
      excludedTitleWords: ['arisa', 'cloe']
    }
  ];

  // STEFANO - capsule ARABELLA / VENERE / ANASTASIA / BELLAMY / BEATRICE
  // (da file taglie.xlsx, handle recuperati da Shopify): nasconde la XS
  // su questi 50 prodotti specifici, indipendentemente da tag o titolo.
  var HANDLE_RULES = [
    {
      size: 'xs',
      handles: [
        // TOP ARABELLA
        'top-arabella-magenta', 'top-arabella-acqua', 'top-arabella-frappe',
        'top-arabella-sky', 'top-arabella-terra-di-siena',
        // TOP VENERE
        'top-venere-magenta', 'top-venere-acqua', 'top-venere-frappe',
        'top-venere-terra-di-siena', 'top-venere-sky',
        // SLIP ARABELLA
        'slip-arabella-magenta', 'slip-arabella-acqua', 'slip-arabella-frappe',
        'slip-arabella-terra-di-siena', 'slip-arabella-sky',
        // CLASSIC SLIP ARABELLA
        'classic-slip-arabella-magenta', 'classic-slip-arabella-acqua',
        'classic-slip-arabella-frappe', 'classic-slip-arabella-sky',
        'classic-slip-arabella-terra-di-siena',
        // SLIP ANASTASIA
        'slip-anastasia-magenta', 'slip-anastasia-acqua', 'slip-anastasia-sky',
        'slip-anastasia-terra-di-siena', 'slip-anastasia-frappe',
        // CLASSIC SLIP ANASTASIA
        'classic-slip-anastasia-magenta', 'classic-slip-anastasia-acqua',
        'classic-slip-anastasia-terra-di-siena', 'classic-slip-anastasia-frappe',
        'classic-slip-anastasia-sky',
        // SLIP BELLAMY
        'slip-bellamy-magenta', 'slip-bellamy-acqua', 'slip-bellamy-sky',
        'slip-bellamy-terra-di-siena', 'slip-bellamy-frappe',
        // CLASSIC SLIP BELLAMY
        'classic-slip-bellamy-magenta', 'classic-slip-bellamy-acqua',
        'classic-slip-bellamy-terra-di-siena', 'classic-slip-bellamy-frappe',
        'classic-slip-bellamy-sky',
        // TOP BEATRICE
        'top-beatrice-magenta', 'top-beatrice-acqua', 'top-beatrice-terra-di-siena',
        'top-beatrice-frappe', 'top-beatrice-sky',
        // SLIP BEATRICE
        'slip-beatrice-magenta', 'slip-beatrice-acqua', 'slip-beatrice-terra-di-siena',
        'slip-beatrice-frappe', 'slip-beatrice-sky'
      ]
    }
  ];

  // STEFANO - cache in memoria: handle -> Promise<{tags, title}>
  var productCache = {};

  function normalize(str) {
    return String(str == null ? '' : str).trim().toLowerCase();
  }

  function containsAny(haystack, words) {
    var h = normalize(haystack);
    return (words || []).some(function (w) {
      return h.indexOf(normalize(w)) !== -1;
    });
  }

  function fetchProduct(handle) {
    if (productCache.hasOwnProperty(handle)) return productCache[handle];

    var p = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('product fetch failed: ' + handle);
        return res.json();
      })
      .then(function (productJson) {
        return {
          tags: Array.isArray(productJson.tags) ? productJson.tags : [],
          title: productJson.title || ''
        };
      })
      .catch(function (err) {
        console.warn('[mm-size-exclusions] errore fetch prodotto "' + handle + '"', err);
        return { tags: [], title: '' };
      });

    productCache[handle] = p;
    return p;
  }

  function ruleMatches(rule, productInfo) {
    var tagsLc = productInfo.tags.map(normalize);
    var tagOk = rule.tag ? tagsLc.indexOf(normalize(rule.tag)) !== -1 : true;
    var excluded = containsAny(productInfo.title, rule.excludedTitleWords);
    return tagOk && !excluded;
  }

  // STEFANO - calcola l'insieme di taglie da nascondere per un prodotto,
  // combinando RULES (per tag) e HANDLE_RULES (per handle esplicito)
  function computeHiddenSizes(handle, productInfo) {
    var hidden = {};

    RULES.forEach(function (rule) {
      if (ruleMatches(rule, productInfo)) {
        hidden[normalize(rule.size)] = true;
      }
    });

    HANDLE_RULES.forEach(function (rule) {
      if ((rule.handles || []).indexOf(handle) !== -1) {
        hidden[normalize(rule.size)] = true;
      }
    });

    return Object.keys(hidden); // es. ['xl', 'xs']
  }

  function markCards(root) {
    var cards = root.querySelectorAll('[data-mm-card][data-handle]');
    cards.forEach(function (card) {
      var handle = card.getAttribute('data-handle');
      if (!handle) return;
      if (card.hasAttribute('data-mm-size-check')) return;
      card.setAttribute('data-mm-size-check', '1');

      fetchProduct(handle).then(function (productInfo) {
        var hiddenSizes = computeHiddenSizes(handle, productInfo);
        card.setAttribute('data-mm-hidden-sizes', hiddenSizes.join(','));
        applySizeFilterForSlot(slotTypeFromCard(card));
      });
    });
  }

  function slotTypeFromCard(card) {
    var slot = card.closest('[data-mm-slot]');
    return slot ? slot.getAttribute('data-mm-slot') : null;
  }

  function applySizeFilterForSlot(type) {
    if (!type) return;
    var root = document.querySelector('[data-mm-bikini]');
    if (!root) return;

    var slot = root.querySelector('[data-mm-slot="' + type + '"]');
    var sizesHolder = root.querySelector('[data-mm-sizes-for="' + type + '"]');
    if (!slot || !sizesHolder) return;

    var activeCard = slot.querySelector('[data-mm-card].is-active');
    var hiddenSizesAttr = activeCard ? activeCard.getAttribute('data-mm-hidden-sizes') : '';
    var hiddenSizes = (hiddenSizesAttr || '').split(',').filter(Boolean);

    sizesHolder.querySelectorAll('[data-mm-size]').forEach(function (btn) {
      var label = normalize(btn.textContent);
      var shouldHide = hiddenSizes.indexOf(label) !== -1;

      if (shouldHide) {
        btn.setAttribute('data-mm-size-hidden', '1');
        btn.style.display = 'none';
      } else if (btn.getAttribute('data-mm-size-hidden') === '1') {
        btn.removeAttribute('data-mm-size-hidden');
        btn.style.display = '';
      }
    });
  }

  function observeSizes(root, type) {
    var sizesHolder = root.querySelector('[data-mm-sizes-for="' + type + '"]');
    if (!sizesHolder) return;

    var mo = new MutationObserver(function () {
      applySizeFilterForSlot(type);
    });
    mo.observe(sizesHolder, { childList: true });
  }

  function init(root) {
    if (root.hasAttribute('data-mm-size-exclusions-init')) return;
    root.setAttribute('data-mm-size-exclusions-init', '1');

    markCards(root);
    observeSizes(root, 'top');
    observeSizes(root, 'slip');

    var trackTop = root.querySelector('[data-mm-track="top"]');
    var trackSlip = root.querySelector('[data-mm-track="slip"]');
    [trackTop, trackSlip].forEach(function (track) {
      if (!track) return;
      var moTrack = new MutationObserver(function () { markCards(root); });
      moTrack.observe(track, { childList: true });
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-mm-bikini]');
    roots.forEach(init);
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(boot, 0);
  } else {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(boot, 0); });
  }
})();